import { injectGlobal } from 'styled-components';
import styled from 'styled-components';
import 'antd/dist/antd.css';
import {
  Black,
  WhiteFour,
  NiceBlue,
  Red,
  DarkishBlue,
  DarkSkyBlue
} from './Colours';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-toastify/dist/ReactToastify.css';
import { device } from './Responsive';

injectGlobal`
  body {
    font-family: 'Montserrat', sans-serif !important;
    margin: 0;
  }

  body.modal-open {
    overflow: hidden;
    position: fixed;
}

  input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
    background-color: transparent !important;
    background-image: none !important;
    color: ${Black} !important;
}

.ant-layout {
  background: ${WhiteFour} !important;
}

.Toastify__toast--error {
  background: ${Red} !important;
}
`;

export const Container = styled.div`
  max-width: 1400px;
  width: 100%;
  margin: auto;
  padding: 0 30px;

  @media only screen and (max-width: 1400px) {
    max-width: 1200px;
  }
  @media only screen and (max-width: 1200px) {
    max-width: 992px;
  }
  @media only screen and (max-width: 992px) {
    max-width: 768px;
  }
  @media only screen and (max-width: 768px) {
    max-width: 100%;
    padding: 0 15px;
  }
`;

export const HeaderSection = styled.div`
  display: inline-block;
  width: 400px;
`;
export const HeaderTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${NiceBlue};
`;
export const HeaderText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.71;
  letter-spacing: 0.4px;
  color: ${NiceBlue};
`;

export const DashboardTitle = styled.div`
  font-size: 24px;
  display: inline-block;
  font-weight: bold;
  line-height: 1.25;
  color: ${NiceBlue};
  margin-top: 20px;
  z-index: 999;

  @media ${device.mobileL} {
    margin-top: 5px;
    margin-right: 5px;
  }
`;

export const DashboardButton = styled.button`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: ${DarkishBlue};
  border: 1px solid ${DarkishBlue};
  background: transparent;
  border-radius: 3px;
  padding: 20px 35px;
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    outline: none;
    box-shadow: none;
    outline-width: 0;
    outline-color: transparent;
  }

  @media ${device.mobileL} {
    padding: 8px 15px;
  }

`;

export const MediumContainer = styled.div`
  display: inline-block;
  width: 100%;
  margin: 100px 0;

  @media ${device.tablet} {
    margin: 50px 0;
  }

  h1 {
    font-size: 40px;
    font-weight: bold;
    line-height: 1.25;
    color: ${NiceBlue};
  }

  h2 {
    font-size: 30px;
    font-weight: bold;
    line-height: 1.33;
    color: ${NiceBlue};
  }

  h3 {
    font-size: 24px;
    font-weight: 300;
    line-height: 1.42;
    color: ${Black};
  }

  p {
    font-size: 16px;
    line-height: 1.88;
    color: ${Black};
  }

  blockquote {
    padding-left: 20px;
    border-left: 2px solid ${NiceBlue};
    font-size: 24px;
    font-style: italic;
    line-height: 1.67;
    color: ${DarkishBlue};
  }

  a {
    color: ${DarkSkyBlue};
    text-decoration: underline;
  }

  img {
    max-width: 100%;
  }

  figure {
    text-align: center;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/BaseStyles.js